import { Divider, Typography, Input } from 'antd'
import { ColumnProps } from 'antd/lib/table'
import moment from 'moment'
import React, { Fragment, useState } from 'react'
import { titles } from '../../setup/messages'
import PaginatedList from '../list/PaginatedList'
import { ITransfer } from './models/ITransfer'
const { Search } = Input;

const TransfersPage: React.FC = () => {
  const endpoint = `/api/transfers`

  const [searchQuery, setSearchQuery] = useState('');

  const columns: Array<ColumnProps<ITransfer>> = [
    {
      dataIndex: 'date',
      key: 'date',
      render: text => moment(text).format('lll'),
      title: 'Date',
    },
    {
      dataIndex: 'senderName',
      key: 'sender',
      title: 'Sender'
    },
    {
      dataIndex: 'receiverName',
      key: 'receiver',
      title: 'Receiver'
    },
    {
      dataIndex: 'value',
      key: 'value',
      title: 'Value'
    },
    {
      dataIndex: 'comment',
      key: 'comment',
      title: 'Message'
    }
  ]

  const handleSearch = (value: string) => {
    console.log("value: ", value)
    setSearchQuery(value);
  };

  return (
    <Fragment>
      <Typography.Title level={2}>{titles.transfers}</Typography.Title>
      <Divider />
      <Search
        placeholder="Nhập email người tặng hoặc nhận..."
        onSearch={handleSearch}
        style={{ marginBottom: 20 }}
      />
      <PaginatedList<ITransfer>
        columns={columns}
        endpoint={endpoint}
        pageSize={10}
        searchQuery={searchQuery}
      />
    </Fragment>
  )
}

export default TransfersPage
